import React from 'react';

const AdSliderThree = () => {
    return (
        <div className={'ad-slider-item ad-slider-three'}> </div>
    );
};

export default AdSliderThree;